<div
  class="cell-row"
  [class.selected]="selectedNode === node"
  [style.paddingLeft.px]="node.depth * 16 + 8"
  (click)="selectNode(node); $event.stopPropagation()"
>
  <span class="cell-icon">
    <nw-icon
      *ngIf="node.hasChildren"
      type="account_tree"
      [size]="12"
      color="#9ca3af"
    ></nw-icon>
    <nw-icon
      *ngIf="node.contentType === 'text'"
      type="text_fields"
      [size]="12"
      color="#9ca3af"
    ></nw-icon>
    <nw-icon
      *ngIf="node.contentType === 'image'"
      type="image"
      [size]="12"
      color="#9ca3af"
    ></nw-icon>
    <nw-icon
      *ngIf="node.contentType === 'video'"
      type="videocam"
      [size]="12"
      color="#9ca3af"
    ></nw-icon>
  </span>
  <span class="cell-label">{{ node.label }}</span>
  <span class="cell-badge" *ngIf="node.type">{{ node.type }}</span>
</div>

<ng-container *ngFor="let child of node.children">
  <nw-layout-cell
    [node]="child"
    [selectedNode]="selectedNode"
    (nodeSelect)="selectNode($event)"
  ></nw-layout-cell>
</ng-container>
